import {apiDeleteAuth, apiGetAuth, apiPostAuth} from '@/utils/api'
import { API_CONSUMER} from '@/utils/api-url'

import {
  notificationDanger
} from '@/utils/notification'

const state = () => {
  return {
    approvalmessage: { data: [] },
    approvalmessageall: { data: [] },
    detail_approval_message: { data: {}},
    meta_filter: {},
    data_modal_add_edit: {},
    toggle_modal_add_edit_discard: {
      targetModals: false,
      title: '',
      description: '',
      customTitleBtnOk: '',
      customClass: '',
      type: '',
      loading: false
    }
  }
}

const mutations = {
  SET_APPROVAL_MESSAGE (state, payload) {
    state.approvalmessage = payload
  },
  SET_APPROVAL_MESSAGE_ALL (state, payload) {
    state.approvalmessageall = payload
  },
  SET_DETAIL_APPROVAL_MESSAGE (state, payload) {
    state.detail_approval_message = payload
  },
  SET_DATA_MODAL_ADD_EDIT (state, payload) {
    state.data_modal_add_edit = payload
  },
  SET_TOGGLE_MODAL_ADD_EDIT_DISCARD (state, payload) {
    state.toggle_modal_add_edit_discard = payload
  },
  SET_META_FILTER (state, payload) {
    state.meta_filter = payload
  }
}

const actions = {
  async getListApprovalMessage (context, payload) {
    try {
      const response = await apiGetAuth(API_CONSUMER.LIST_APPROVAL_MESSAGE, payload)
      context.commit('SET_APPROVAL_MESSAGE', response.data.data)
      context.commit('SET_META_FILTER', payload)
    } catch (error) {
      notificationDanger(error)
    }
  },
  async getListApprovalMessageAll (context, payload) {
    try {
      const response = await apiGetAuth(API_CONSUMER.LIST_APPROVAL_MESSAGE_ALL, payload)
      context.commit('SET_APPROVAL_MESSAGE_ALL', response.data.data)
      context.commit('SET_META_FILTER', payload)
    } catch (error) {
      notificationDanger(error)
    }
  },
  async deleteApprovalMessage (context, payload) {
    try {
      const response = await apiDeleteAuth(API_CONSUMER.DELETE_APPROVAL(payload))
      return response.data
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,
        title: '',
        description: '',
        customTitleBtnOk: '',
        customClass: '',
        type: '',
        loadingTable: false,
        loadingPopUp: false
      })
      notificationDanger(error)
    }
  },
  async createApprovalMessage (context, payload) {
    try {
      const response = await apiPostAuth(API_CONSUMER.CREATE_APPROVAL, payload)
      return response.data
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,
        title: '',
        description: '',
        customTitleBtnOk: '',
        customClass: '',
        type: '',
        loadingTable: false,
        loadingPopUp: false
      })
      notificationDanger(error)
    }
  }
}

const getters = {
  list_approval_message (state) {
    return state.approvalmessage
  },
  list_approval_message_all (state) {
    return state.approvalmessageall
  },
  get_data_modal_add_edit (state) {
    return state.data_modal_add_edit
  },
  get_toggle_modal_add_edit_discard (state) {
    return state.toggle_modal_add_edit_discard
  },
  meta_filter (state) {
    return state.meta_filter
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
